import React, { useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import "./survey.scss";
import defaultProfile from "../../assets/default-profile.png";
import formatDate from "../../utils/helpers/formatDate";
import sortByRecentDate from "../../utils/helpers/sortByRecentDate";

interface Survey {
  id: number;
  attemptedUserCount: number;
  in_group: number;
  name: string;
  url: string;
  type: string;
}

const SurveyTable = () => {
  const cmpMounted = useRef(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [surveyData, setSurveyData] = useState<Survey[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [groupNames, setGroupNames] = useState([]);
  const [attemptedUsers, setAttemptedUsers] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchSurvey();
  }, []);

  const handlePageChange = (page: number) => {
    // console.log("PAGE",page)
    fetchSurvey(page+1);
  };


  const fetchSurvey = async (page:number = 1) => {
    try {
      dispatch(showLoader("Loading data..."));
      const payload = {
        pageSize: 10,
        pageNumber: page,
      }
      // const response = await postDetails(APIList.GET_ALL_SURVEY, payload);
      const response = await postDetails(APIList.GET_ALL_SURVEY, {});
      console.log("survey response",response);

      const modifiedSurvey = response.data.data.map((item:any)=>(
        {
          ...item,
          url: item.url ? item.url : "N/A"
        }
      ))

      setSurveyData(modifiedSurvey);
      setTotalRecords(response.data.totalcount);
    } catch (error) {
      console.log("Error Fetching Survey data", error);
      dispatch(showToast(`Some error occurred while getting survey details`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleGetGroupById = async (item: any) => {
    try {
      const response = await postDetails(APIList.GET_SURVEY_GROUP_DATA, {
        id: item.id,
      });
      console.log(response.data);
      if (Array.isArray(response.data) && response.data.length !== 0) {
        const filteredGroupNames = response.data.map(
          (item: any) => item.groupName
        );
        setGroupNames(filteredGroupNames);
        setShowGroupModal(true);
      }
    } catch (error) {
      console.log("Cannot get group details", error);
      dispatch(showToast(`Some error occurred while getting group details`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleSurveyEdit = async (item: any) => {
    navigate("/survey/edit", { state: { isEdit: true, data: item } });
  };

  const handleSurveyDelete = async (item: Survey) => {
    try {
      const response = await postDetails(APIList.DELETE_SURVEY, {
        id: item.id,
      });
      if (response.status === "Failed") {
        dispatch(showToast(`Cannot delete survey`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("Survey Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchSurvey();
    } catch (error) {
      console.log("Some error occured while deleting Survey", error);
    }
  };

  const handleGetAttemptedUsers = async (item: Survey) => {
    console.log(item.id);
    try {
      const response = await postDetails(APIList.GET_ATTEMPTED_USERS, {
        id: item.id,
      });
      console.log(response.data);
      if (Array.isArray(response.data) && response.data.length !== 0) {
        const sortedData = sortByRecentDate(response.data, "created");

        setAttemptedUsers(sortedData || []);
        setShowUserModal(true);
      }
    } catch (error) {
      console.log("Error fetching users who attempted survey");
      dispatch(showToast(`Some error occurred while fetching attempted users`));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  // const handleViewSurveyQuiz = (item: Survey) => {
  //   navigate(`/survey/quiz/${item.id}`, { state: item });
  // };

  const handleViewSurveyQuiz = (item: Survey) => {   navigate(`/survey/${item.name}`, {     state: { id: item.id },  }); };
 

  const columns: TableColumn[] = [
    // {
    //   key: "groupData",
    //   label: "Assignee",
    //   // search:true,
    //   render: (item) => {
    //     return (
    //       <div
    //         className="text-primary cursor-pointer text-decoration-underline"
    //         onClick={() => handleGetGroupById(item)}
    //       >
    //         {" "}
    //         {item.is_group === 1 ? item.groupData : "All Employee"}  
    //                 </div>
    //     );
    //   },
    // },
    {
      key: "groupData",
      label: "Assignee",
      render: (item) => {
        if (item.is_group === 1 && item.groupData) {
          return (
            <div
              className="text-primary cursor-pointer text-decoration-underline"
              onClick={() => handleGetGroupById(item)}
            >
              {item.groupData}
            </div>
          );
        }
    
        // Render plain text for "All Employee" or if groupData is not available
        return <div>{item.is_group === 0 ? "All Employee" : item.groupData || ""}</div>;
      },
    },
    
        { key: "name", label: "Survey name", sortable: true , dataType:"string",},
        { key: "surveyImage", label: "Survey Image",
          dataType: "image",
          //  render: (item) =>{
          //  if(item.surveyImage !== null){
          //   return (
          //     <img src={item.surveyImage} alt="Survey Image" width={50}  />
          //   )
          //  }}
      },
        { key: "url", label: "Survey URL" , dataType: "string",
          // render: (item) => {
          //   return (
          //     item.url ? item.url : "N/A"
          //   )
          // },
          sortable: true},
        {
          key: "quizCount",
          label: "View Quiz",
          render: (item) => {
            if (item.type === "Quiz") {
              return (
                <button className='btn-sm btn-warning text-white' onClick={()=> handleViewSurveyQuiz(item)}>View Quiz</button>
              );
            } else {
              return null; 
            }
          },
        },       
        { key: "attemptedUserCount", 
          label: "Users Completed",
          // search:true,
          render: (item) => {
              return ( <div className="text-primary cursor-pointer text-decoration-underline" onClick={()=>handleGetAttemptedUsers(item)}> {item.attemptedUserCount || 0} </div> )
          },
    },
  ];

  const closeGroupModal = () => setShowGroupModal(false);

  const closeUserModal = () => setShowUserModal(false);

  return (
    <div>
      <Modal show={showGroupModal} onHide={closeGroupModal}>
        <Modal.Header closeButton>
          <Modal.Title>{"Group Name"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              height: "300px",
              overflowY: "auto",
              //  padding: "10px",
              fontSize: "14px",
            }}
          >
            {groupNames.length !== 0 ? (
              <ol>
                {groupNames.map((name, index) => (
                  <li key={index}>{name}</li>
                ))}
              </ol>
            ) : (
              <p>No Group found!</p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showUserModal} onHide={closeUserModal}>
        <Modal.Header closeButton>
          <Modal.Title>{"Users Completed"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              height: "300px",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            {/* {
          attemptedUsers.length !== 0 ?
           (<ol>
        { attemptedUsers.map((user:any, index:number)=> 
        <li key={index}>{user.username}</li>
         )}
       </ol>) : (<p>No User found!</p>)
    } */}
            {attemptedUsers.map((user: any) => (
              <div
                key={user.id}
                className="d-flex my-2 justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <img
                    src={user.profile ? user.profile : defaultProfile}
                    alt="Profile Picture"
                    className="mx-2"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  />
                  <div className="">
                    <p
                      className="text-start px-2"
                      style={{ fontWeight: "700", fontSize: 16, marginBottom: "0.5rem" }}
                    >
                      {user.username || "User Name Not Available"}
                    </p>
                    <p className="text-start px-2" style={{ fontSize: 14 }}>
                      {user.created
                        ? new Date(user.created).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : "Date Not Available"}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
      <CommonTable<Survey>
        data={surveyData}
        columns={columns}
        onEdit={handleSurveyEdit}
        onDelete={handleSurveyDelete}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: false,
          status: false,
        }}
        // onPageChange={handlePageChange}
        // apiPagination={true}
        // totalPageCount={totalRecords}
      />
    </div>
  );
};

export default SurveyTable;
